<template>
  <v-text-field
    v-model="inputVal"
    :label="label || $t('generic.search')"
    :autofocus="autofocus"
    :name="name"
    :autocomplete="resolvedAutocomplete"
    prependInnerIcon="$search"
    :placeholder="placeholder"
    class="bm-search-input"
    clearable
    @keyup.enter="emit('keyupEnter')"
  >
  </v-text-field>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { vuetifyInputReplacer } from '@/helpers/dataCcReplacer';

interface Props {
  autofocus?: boolean;
  label?: string;
  placeholder?: string;
  name?: string;
  autocomplete?: string;
}

const props = withDefaults(defineProps<Props>(), {
  autofocus: false,
  label: '',
  placeholder: ''
});

const resolvedAutocomplete = computed(() => {
  const normalizedAutocomplete = props.autocomplete?.trim().toLowerCase();
  const hasName = Boolean(props.name?.trim());

  if (!hasName) return 'off';
  if (normalizedAutocomplete === 'off') return 'off';

  return 'on';
});

const inputVal = defineModel<string>();

const emit = defineEmits<{
  keyupEnter: [];
}>();

onMounted(() => {
  vuetifyInputReplacer('bm-search-input', 'search-input');
});
</script>
